import { z } from 'zod';
export const ChecklistItemInput = z.object({
    id: z.uuid(),
    text: z.string().trim().min(1).max(500),
    weight: z.number().positive().max(100).multipleOf(0.01).nullable(),
});
export const ChecklistItemsInput = z
    .array(ChecklistItemInput)
    .max(100)
    .superRefine((items, ctx) => {
    if (new Set(items.map((item) => item.id)).size !== items.length) {
        ctx.addIssue({ code: 'custom', message: 'CHECKLIST_DUPLICATE_ID' });
    }
    const specified = items.reduce((sum, item) => sum + Math.round((item.weight ?? 0) * 100), 0);
    const automatic = items.filter((item) => item.weight === null).length;
    if (items.length > 0 &&
        (specified > 10000 ||
            (automatic === 0 && specified !== 10000) ||
            (automatic > 0 && specified >= 10000))) {
        ctx.addIssue({ code: 'custom', message: 'CHECKLIST_INVALID_WEIGHTS' });
    }
});
export const TaskChecklist = z.object({
    items: z
        .array(ChecklistItemInput.extend({ checked: z.boolean() }))
        .min(1)
        .max(100),
});
export const ConfigureChecklistInput = z.object({
    items: ChecklistItemsInput,
    version: z.number().int().nonnegative(),
});
export const ToggleChecklistInput = z.object({ checked: z.boolean() });
/** Keep automatic shares unrounded; only round the final task percentage. */
export function checklistWeights(items) {
    const explicit = items.reduce((sum, item) => sum + Math.round((item.weight ?? 0) * 100), 0) / 100;
    const automatic = items.filter((item) => item.weight === null).length;
    const share = automatic === 0 ? 0 : (100 - explicit) / automatic;
    return items.map((item) => item.weight ?? share);
}
export function checklistProgress(checklist) {
    if (checklist.items.every((item) => item.checked))
        return 100;
    const weights = checklistWeights(checklist.items);
    // Never show 100% while a small-weight item remains unchecked.
    return Math.min(99, Math.round(checklist.items.reduce((sum, item, index) => sum + (item.checked ? weights[index] : 0), 0)));
}
//# sourceMappingURL=task-checklist.js.map